import { computed } from "vue";

const mockSports = [
    "motor-racing",
    "cycling",
    "golf",
    "politics",
    "novelties-specials",
    "winter-sports",
    "ski-jumping",
    "alpine-skiing",
    "biathlon",
    "skiing",
];

export default function useTournamentSports() {
    const tournamentSports = computed(() => {
        const config = environment.config;
        const configSports = config["tournament-sports"]?.tournamentSportCodes;
        return configSports ? configSports : mockSports;
    });

    const isTournamentSport = (sportCode: string) => tournamentSports?.value?.includes(sportCode);

    return { isTournamentSport };
}
